import { lazy } from 'react';

const SellersPage = lazy(() => import('../pages/Sellers.page'));
const AddSellerPage = lazy(() => import('../pages/AddSeller.page'));
const AddEmployeePage = lazy(() => import('../pages/AddEmployee.page'));

const SellersRoutes = [
    {
        path: '/sellers',
        element: <SellersPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/sellers/add',
        element: <AddSellerPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/sellers/employees/add',
        element: <AddEmployeePage />,
        layout: 'default',
        isAuthReq: true,
    },
];
export { SellersRoutes };
